// 並行リクエストのレスポンス到着順逆転による古いデータでのstate上書きを防ぐためのヘルパー。
// mode で世代判定の基準を選ぶ。
//  - "applied"(既定): 「自分より後のリクエストの結果が既に反映済みか」で判定。同一条件の再取得向けで、
//      リトライ等で後続リクエストを発行しても、先に完了した中間リクエストの結果を捨てずに済む。
//  - "issued": 「自分より後のリクエストが発行済みか」で判定。パラメータが変わり得る取得向けで、
//      切り替え後に旧パラメータのレスポンスが反映されるのを防ぐ。
export function createLatestRequestGuard({ mode = "applied" } = {}) {
  let issuedRequestId = 0;
  let appliedRequestId = 0;

  // リクエスト発行時に呼び出す。成功/失敗どちらのコールバックからも同じ世代判定を参照できる
  return function registerRequest() {
    const requestId = ++issuedRequestId;
    const isStale = () => mode === "issued"
      ? requestId < issuedRequestId
      : requestId < appliedRequestId;

    return {
      isStale,
      guard(callback) {
        return (...args) => {
          if (isStale()) {
            return false;
          }
          appliedRequestId = requestId;
          callback(...args);
          // 呼び出し側が破棄されたレスポンスを副作用（時刻オフセット計算等）に使わないよう判定結果を返す
          return true;
        };
      },
    };
  };
}
